import { PayloadAction } from '@reduxjs/toolkit';
import { put, select, takeLatest } from 'redux-saga/effects';
import { SpaceId } from 'api/models';
import { SpaceTabAPI } from 'api/space';
import { HistoryPayload } from 'data/core';
import { removeSpaceTabFromSpace, Space } from 'data/spaces';
import { getSpaceByIdSelector } from 'data/spaces/selectors';
import { getSpaceDetailUrl } from 'utils/urls';
import { deleteSpaceTabSagaAction } from '../actions';
import { deleteFailure, deleteStart, deleteSuccess, SpaceTab } from '../index';
import { getSpaceTabByIdSelector } from '../selectors';

function* deleteSpaceTabSaga(action: PayloadAction<HistoryPayload<number>>) {
  const { payload } = action;
  const { data, history } = payload;
  const spaceTab = (yield select(getSpaceTabByIdSelector(data))) as SpaceTab;
  const { spaceId, project } = (yield select(
    getSpaceByIdSelector(spaceTab.space),
  )) as Space;

  try {
    yield put(deleteStart());
    yield SpaceTabAPI.deleteSpaceTab(data);
    yield put(deleteSuccess(data));
    yield put(removeSpaceTabFromSpace({ spaceId, spaceTabId: String(data) }));
    yield history.push(getSpaceDetailUrl(SpaceId(project, spaceId)));
  } catch (error) {
    yield put(deleteFailure());
    yield history.push(getSpaceDetailUrl(SpaceId(project, spaceId)));
  }
}

export function* watchDeleteSpaceTabSaga(): Generator {
  yield takeLatest(deleteSpaceTabSagaAction.type, deleteSpaceTabSaga);
}
